import { render, staticRenderFns } from "./TriggerModalDutySpecific.vue?vue&type=template&id=5b2af22e"
import script from "./TriggerModalDutySpecific.vue?vue&type=script&lang=ts"
export * from "./TriggerModalDutySpecific.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports